<div class="record-meta" *ngIf="record">
  <span><span class="record-meta-label">Created by</span>{{record.createdBy || '—'}}</span>
  <span><span class="record-meta-label">Create date &amp; time</span>{{(record.created | date:'M/d/yyyy h:mm a') || '—'}}</span>
  <span><span class="record-meta-label">Last updated by</span>{{record.lastModifiedBy || '—'}}</span>
  <span><span class="record-meta-label">Last update date &amp; time</span>{{(record.lastModified | date:'M/d/yyyy h:mm a') || '—'}}</span>
</div>
